import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileInfo } from '@classes/file/fileInfo';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  private readonly baseUrl: string = environment.apiUrl + 'file';

  constructor(
    private _http: HttpClient
  ) { }

  public postFile(fileToUpload: File): Observable<FileInfo> {
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    return this._http.post<FileInfo>(this.baseUrl, formData);
  }
}
